import secureLocalStorage from "react-secure-storage";
import React from "react";
import ReactDOM from "react-dom";
import {
  Grid,
  GridColumn as Column,
  GridToolbar,
} from "@progress/kendo-react-grid";
import {  NavLink } from "react-router-dom";
import Api from "../../Services/Api";
import { Popup } from "@progress/kendo-react-popup";
import { CircularProgress } from "@material-ui/core";
import { toastr } from "react-redux-toastr";
import Images from "../../Assets/Images";
import AddUserControl from "./AddUserControl";
import ManageUserControl from "./ManageUserControl";

class UserControl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      userList: [],
      skip:0,
      take:10,
      openWorkstreamModelFlagView:false
    };
  }
  pageChange = (event) => {
    this.setState({
        skip: event.page.skip,
        take: event.page.take,
    });
};

  
  componentDidMount() {
    this.isAuthorizeUse();
   
  }
  isAuthorizeUse = () => {
    // if (!secureLocalStorage.getItem("loginUserId")) {
    //   this.props.history.push({
    //     pathname: `/unauthorized`,
    //   });
    // }else{
      this.getPMOUsers();
    // }
  };
  getPMOUsers = async () => {
    try {
      this.setState({ ...this.state, loader: true });
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient == "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      var request = {
        CreatedBy: parseInt(createdby),
      };
      let response = await Api.GetPMOUsers(request);
      if (response.status === 200 && response.tenantUsers) {
        this.setState({
          ...this.state,
          userList: response.tenantUsers,
          loader: false,
          openWorkstreamModelFlagView:false
        });
      } else {
        this.setState({ ...this.state, userList: [], loader: false });
      }
    } catch (error) {
      this.setState({ ...this.state, userList: [], loader: false });

      console.error(error);
    }
  };

  openWorkstreamPopupOpen=(data)=>{

    // let arr=[];
    // data.workstreamRoles&&data.workstreamRoles.map((item)=>{
    //   arr.push(item.workstreamId);
    // });
    // let obj={
    //   name: data.name,
    //   userId: data.userId,
    //   workStreamIds: arr,
    //   workstreamRoles:data.workstreamRoles
    // }
    this.setState({...this.state,openWorkstreamModelFlagView:true,dataItem:data});
  }
  openWorkstreamPopupClose=(event)=>{
    this.getPMOUsers();
    this.setState({...this.state,openWorkstreamModelFlagView:false});
    
  }

  actionButtons = (event) => {
    let eventData = event.dataItem;
    return (
      <td className=" editBtns">
        
          <ul className="actionIcon">
            <li>
              <a
                title="Manage workstream"
                onClick={() => this.openWorkstreamPopupOpen(eventData)}
                className="greenbtn icon"
              >
                <img src={Images.EDITICON} width="10" alt="edit" />
              </a>
            </li>
           
          </ul>
        
      </td>
    );
  };
  render() {
    return (
      <div className="riskTypeCont">
        <div className="dbCard card100 noPadd">
          <div className="gridBox">
            <div className="tblCont dataGrids noPaddTop">
              <div className="rw-tab-content">
                <Grid
                  
                  data={ this.state.userList.slice(
                    this.state.skip,
                    this.state.take + this.state.skip
                )  }


                  reorderable
                  resizable
                  sortable={true}

                  pageable={true}
                  skip={this.state.skip}
                  take={this.state.take}
                  total={this.state.userList.length}
                  onPageChange={this.pageChange}
                >
                  <GridToolbar className="customHeader">
                    <div className="gridHeader">
                      <div className="d-flex align-items-center">
                        <h4>Manage User Access</h4>
                        <div className="ml-auto d-flex">
                          <div className="btnGreen noMargin">
                            {/* <button >Add Control</button> */}

                            <NavLink style={{width:"120px"}}
                              to={`/${secureLocalStorage.getItem(
                                "loggedClient"
                              )}/${secureLocalStorage.getItem(
                                "tenantKey"
                              )}/home/addusercontrol`}
                            >
                              Assign User
                            </NavLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </GridToolbar>
                  <Column field="name" title="Name" />
                  {/* <Column field="role" title="Role" /> */}
                  <Column field="jobTitle" title="Job Title" />
                  <Column field="telephone" title="Telephone" />
                  {/* <Column field="workStreamNames" title="Workstream" format=""/> */}
                  <Column
                    field="workStreamNames"
                    title="Workstreams"
                    cell={(props) => 
                      <td>
                        <div>
                        {props.dataItem.workstreamRoles&&props.dataItem.workstreamRoles.map((item,index) => (
                        <span title={item.role} >{item.workstreamName}{props.dataItem.workstreamRoles.length-1!=index?",":" "}</span>
                        )
                         
                        )}
                        </div>
                      </td>
                    }
                  />
                  <Column field=""  title="Actions" cell={this.actionButtons}/>
                </Grid>
              </div>
            </div>
          </div>
        </div>

        <Popup
            show={this.state.openWorkstreamModelFlagView}
            popupClass={"popup-content"}
          >
            {this.state.loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <div className="deleteModelCont">
              <ManageUserControl {...this.props} dataItem={this.state.dataItem}
               openWorkstreamPopupClose={this.openWorkstreamPopupClose}
                ref="childManageUser"
               >
               </ManageUserControl>
              
            </div>
          </Popup>
      </div>
    );
  }
}

export default UserControl;
